// src/components/SurveyLibraryModal.js
import React, { useState } from 'react';
import { SURVEY_TYPES } from './surveyParsers';

const TYPE_LABELS = {
  onboarding: 'Paid Media Onboarding Doc',
  ...Object.fromEntries(SURVEY_TYPES.map(t => [t.id, t.label])),
};

export default function SurveyLibraryModal({ client, onClose }) {
  const [openType, setOpenType] = useState(null);
  const surveys = client.surveys || {};
  const keys = Object.keys(surveys);

  const overlayStyle = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
    zIndex: 270, padding: 20, overflowY: 'auto',
  };
  const modalStyle = {
    background: '#fff', borderRadius: 12, width: '100%', maxWidth: 700,
    border: '1px solid rgba(0,0,0,0.15)', margin: 'auto',
    fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
  };

  return (
    <div style={overlayStyle} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={modalStyle}>
        <div style={{
          padding: '13px 18px', borderBottom: '1px solid rgba(0,0,0,0.1)',
          display: 'flex', alignItems: 'center', gap: 10,
        }}>
          <div style={{ fontSize: 16, fontWeight: 800, flex: 1, color: '#1a1a18' }}>
            📚 Surveys on File — {client.name}
          </div>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: 18, color: '#999', padding: '2px 6px',
          }}>✕</button>
        </div>

        <div style={{ padding: 18 }}>
          {keys.length === 0 ? (
            <div style={{ fontSize: 13, color: '#888' }}>
              No surveys imported yet for this client. Use 📥 Import Survey to add one.
            </div>
          ) : (
            keys.map(k => {
              const entry = surveys[k];
              const isOpen = openType === k;
              return (
                <div key={k} style={{ marginBottom: 8, border: '1px solid rgba(0,0,0,0.12)', borderRadius: 8 }}>
                  <button
                    onClick={() => setOpenType(isOpen ? null : k)}
                    style={{
                      width: '100%', textAlign: 'left', padding: '10px 12px',
                      background: '#fafaf8', border: 'none', cursor: 'pointer',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      fontFamily: 'inherit', borderRadius: isOpen ? '8px 8px 0 0' : 8,
                    }}
                  >
                    <span style={{ fontWeight: 700, fontSize: 13, color: '#1a1a18' }}>
                      {TYPE_LABELS[k] || k}
                    </span>
                    <span style={{ fontSize: 11, color: '#999' }}>
                      {entry.savedAt ? new Date(entry.savedAt).toLocaleString() : ''} {isOpen ? '▲' : '▼'}
                    </span>
                  </button>
                  {isOpen && (
                    <pre style={{
                      margin: 0, padding: 12, fontSize: 12, lineHeight: 1.5,
                      whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                      background: '#fff', color: '#333', maxHeight: 400, overflowY: 'auto',
                      borderTop: '1px solid rgba(0,0,0,0.08)',
                    }}>
                      {entry.raw}
                    </pre>
                  )}
                </div>
              );
            })
          )}
        </div>

        <div style={{
          padding: '12px 18px', borderTop: '1px solid rgba(0,0,0,0.1)',
          display: 'flex', justifyContent: 'flex-end',
        }}>
          <button onClick={onClose} style={{
            fontSize: 12, padding: '7px 14px', borderRadius: 7,
            background: '#f5f5f3', color: '#333', border: '1px solid rgba(0,0,0,0.18)',
            cursor: 'pointer', fontFamily: 'inherit',
          }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
